import { useTranslation } from 'react-i18next';
import catImage from '@assets/images/order-form-price-info-cat.svg';



const PriceInfo = () => {
	const { t } = useTranslation('forms');

	return (
		<div className='price-info-section'>

			<div className='info-text'>{t('priceInfo.sectionLabel')}</div>

			<div></div>

			<div className='info-item middle-size'>
				<p>{t('priceInfo.catSize.title')}</p>
				<p>{t('priceInfo.catSize.text')}</p>
				<img src={catImage} alt='price-info-middle-cat-image' />
			</div>

			<div></div>

		</div>
	);
};

export default PriceInfo;